import {firebaseAction} from "vuexfire";
import constants from "@/config/constants";
import firebase from "firebase/app";
import axios from "axios";

const getAntiFrostTemp = function (device) {
    if (device.data.type === constants.deviceTypes.acs)
        return getRealTemp(constants.acsIceModeTemp, device);
    else return getRealTemp(constants.iceModeTemp, device);
};

const getRealTemp = function (temp, device) {
    if (device.data.user_mode) {
        if (temp < device.data.um_min_temp) return device.data.um_min_temp;
        else if (temp > device.data.um_max_temp) return device.data.um_max_temp;
    }
    return temp;
};

export default {
    namespaced: true,
    state: {
        current: {
            data: {},
            firmware: {},
        },
        remoteConfig: {schedules_4: []},
    },

    getters: {},
    actions: {
        //BINDINGS
        bindCurrent: firebaseAction(({bindFirebaseRef}, ref) => {
            return new Promise((resolve) => {
                bindFirebaseRef("current", ref, {
                    readyCallback() {
                        resolve();
                    },
                });
            });
        }),

        setCurrent: function (context, idDevice) {
            return new Promise((resolve) => {
                context
                    .dispatch(
                        "bindCurrent",
                        firebase.database().ref("devices").child(idDevice)
                    )
                    .then(() => resolve());
            });
        },

        //UPDATE FIREBASE OBJECT

        update: function (_, {device, payload}) {
            payload.last_sync_datetime_app = Date.now();
            return firebase
                .database()
                .ref("devices")
                .child(device.serialnumber)
                .child("data")
                .update(payload);
        },

        //THERMOSTAT

        setStatus: function (context, {device, status}) {
            let payload = {
                mode: constants.modes.manual,
                status: status,
                temp: getRealTemp(device.data[status], device),
            };
            if (status === constants.status.ice)
                payload.temp = getAntiFrostTemp(device);
            context.dispatch("update", {device, payload});
        },

        setMode: function (context, {device, mode}) {
            let payload = {mode: mode};
            context.dispatch("update", {device, payload});
        },

        setPower: function (context, {device, power}) {
            let payload = {power: power};
            context.dispatch("update", {device, payload});
        },

        setLegionellaConfig: function (context, {device, config}) {
            let payload = {legionella_conf: config};
            context.dispatch("update", {device, payload});
        },

        setTemperature: function (context, {device, temperature}) {
            let payload = {
                temp: getRealTemp(temperature, device),
                mode: constants.modes.manual,
                status: constants.status.none,
            };

            if (payload.temp === getAntiFrostTemp(device))
                payload.status = constants.status.ice;

            if (device.data.eco && payload.temp === device.data.eco)
                payload.status = constants.status.eco;
            else if (device.data.comfort && payload.temp === device.data.comfort)
                payload.status = constants.status.comfort;

            context.dispatch("update", {device, payload});
        },

        //SETTINGS

        setAdvancedSettings: function (context, {device, form, inherit = true}) {
            // TODO: backlight ver si es en update o advanced
            // TODO: ice_mode ver el ?? y pilot_mode
            // TODO: ice ver el ??
            // TODO: ver legionella y legionella_conf
            // TODO: ver nominal_power pero creo q nada
            // TODO: ver pir_mode
            // TODO: ver power
            if (device.data.type === constants.deviceTypes.acs) {
                form.comfort = form.comfort
                    ? form.comfort
                    : constants.ranges.comfort.acs.min;

                form.eco = form.eco ? form.eco : constants.ranges.eco.acs.min;
            } else {
                form.comfort = form.comfort
                    ? form.comfort
                    : constants.ranges.comfort.radiator.min;
                form.eco = form.eco ? form.eco : constants.ranges.eco.radiator.default;
            }

            let payload = {
                pilot_mode: form.hilo_pilot,
                eco: form.eco,
                comfort: form.comfort,
                ice_mode: form.ice_mode,
            };

            //CHECK IF IS CALLED BY ZONE REPO OR DIRECTLY BY COMPONENT
            payload.block_local = form.block_local ? form.block_local : false;
            payload.block_remote = form.block_remote ? form.block_remote : false;

            if (form.pre_config !== undefined) {
                payload.schedule_type = form.pre_config;
            }

            // sonda
            if (form.use_floor_probe !== undefined) {
                payload.use_floor_probe = form.use_floor_probe;

                if (
                    !form.use_floor_probe &&
                    device.data.temp > constants.ranges.thermostat.therm.max
                ) {
                    payload.temp = constants.ranges.thermostat.therm.max;
                }
            }
            form.ice = form.ice ? form.ice : constants.ice;
            // bright
            if (form.backlight !== undefined || form.backlight !== null) {
                payload.backlight = form.backlight;
            }

            if (form.backlight_on !== undefined || form.backlight_on !== null) {
                payload.backlight_on = form.backlight_on;
            }

            if (form.backlight_time !== undefined || form.backlight_time !== null) {
                payload.backlight_time = form.backlight_time;
            }

            // hotel
            if (!form.hotel_mode) {
                payload.user_mode = false;
            } else {
                payload.user_mode = true;
                payload.block_remote = true;
            }

            payload.buzzer = form.buzzer ? form.buzzer : false;

            if (form.offset_probe !== undefined) {
                payload.offset_probe = form.offset_probe;
            }

            // adelanto
            payload.adelanto_enable = form.adelanto_enable
                ? form.adelanto_enable
                : false;

            if (inherit) payload.pilot_mode = form.pilot_mode;

            switch (device.data.type) {
                case constants.deviceTypes.acs:
                    payload.legionella_conf = form.legionella_conf;
                    break;
                case constants.deviceTypes.radiator:
                    if (!inherit) {
                        payload.windows_open_mode = form.windows_opened;
                        payload.pir_mode = form.presence_mode;
                    } else {
                        payload.windows_open_mode = form.windows_open_mode;
                        payload.pir_mode = form.pir_mode;
                    }
                    break;
                case constants.deviceTypes.radiatorb:
                    if (!inherit) {
                        payload.windows_open_mode = form.windows_open_mode;
                        payload.pir_mode = form.presence_mode;
                    } else {
                        payload.windows_open_mode = form.windows_open_mode;
                        payload.pir_mode = form.pir_mode;
                    }
                    break;
                case constants.deviceTypes.oval_towel:
                    payload.two_hours = form.two_hours;
                    if (!inherit) {
                        payload.windows_open_mode = form.windows_open_mode;
                        payload.pir_mode = form.presence_mode;
                    } else {
                        payload.windows_open_mode = form.windows_open_mode;
                        payload.pir_mode = form.pir_mode;
                    }
                    break;
                case constants.deviceTypes.towel:
                    payload.windows_open_mode = form.windows_open_mode;
                    payload.two_hours = form.two_hours;
                    break;
            }

            if (device.data.status !== constants.status.none) {
                if (device.data.status === constants.status.ice)
                    payload.temp = getAntiFrostTemp(device)
                        ? getAntiFrostTemp(device)
                        : 21;
                // IS IT NECESSARY?
                else
                    payload.temp = getRealTemp(form[device.data.status], device)
                        ? getRealTemp(form[device.data.status], device)
                        : 21;
            }

            for (const property in payload) {
                if (payload[property] === undefined){
                   delete payload[property]
                }
            }

            context.dispatch("update", {device, payload});
        },

        async getDeviceSchedule(context, {device}) {
            if (
                device.data.schedule_type === undefined ||
                device.data.schedule_type === null ||
                (device.data.type !== constants.deviceTypes.therm &&
                    device.data.schedule_type === constants.ownScheduleValue) ||
                (device.data.type === constants.deviceTypes.therm &&
                    device.data.schedule_type === constants.ownScheduleValueTherm)
            ) {
                return device.data.schedule;
            }

            // preconfig
            const remoteConfig = firebase.remoteConfig();
            remoteConfig.settings.minimumFetchIntervalMillis = 5000;
            remoteConfig.defaultConfig = context.state.remoteConfig;
            await remoteConfig.fetchAndActivate();
            const value = remoteConfig
                .getValue("schedules_4_" + device.data.type)
                .asString();
            const configs = JSON.parse(value);
            return configs[
                device.data.schedule_type === 0
                    ? device.data.schedule_type
                    : device.data.schedule_type - 1
                ];
        },

        setWindowMode: function (context, {device, value}) {
            let payload = {windows_open_mode: value};
            context.dispatch("update", {device, payload});
        },

        setLockMode: function (context, {device, value}) {
            let payload = {block_remote: false, block_local: value};
            context.dispatch("update", {device, payload});
        },

        setBoostMode: function (context, {device, value}) {
            let payload = {two_hours: value};
            context.dispatch("update", {device, payload});
        },

        setLockRemoteMode: function (context, {device, value}) {
            let payload = {block_remote: value, block_local: false};
            context.dispatch("update", {device, payload});
        },

        setUserModePassword: function (context, {device, password}) {
            let payload = {um_password: password};
            context.dispatch("update", {device, payload});
        },

        setUserMode: function (context, {device, form}) {
            return new Promise((resolve) => {
                let payload = {
                    um_min_temp: form.um_min_temp,
                    um_max_temp: form.um_max_temp,
                    user_mode: form.user_mode,
                };

                if (payload.user_mode) {
                    if (device.data.eco < payload.um_min_temp)
                        payload.eco = payload.um_min_temp;
                    if (device.data.comfort > payload.um_max_temp)
                        payload.comfort = payload.um_max_temp;
                }

                context.dispatch("update", {device, payload}).then(() => {
                    //UPDATE STATE
                    if (
                        payload.user_mode &&
                        device.data.mode === constants.modes.manual
                    ) {
                        let updatedDevice = context.state.current;

                        if (device.data.status === constants.status.none)
                            context.dispatch("setTemperature", {
                                device: updatedDevice,
                                temperature: device.data.temp,
                            });
                        else
                            context.dispatch("setStatus", {
                                device: updatedDevice,
                                status: status,
                            });
                    }

                    resolve();
                });
            });
        },

        //PROGRAM

        setProgram: function (context, {device, program}) {
            return new Promise((resolve) => {
                let payload = {
                    schedule: program,
                };
                context.dispatch("update", {device, payload});
                resolve();
            });
        },

        //STATISTICS

        setStatistics(context, payload) {
            let devices = [];
            devices.push(context.state.current.serialnumber);

            //ACTION ON STATISTICS WITH DEVICES AND DATE
            return context.dispatch(
                "statistics/setData",
                {filters: payload, devices: devices},
                {root: true}
            );
        },

        //WARMUP

        updateWithWarmUpInfo(context, device) {
            let payload = JSON.stringify({
                userid: context.rootState.user.current.uid,
                deviceNumber: device.serialnumber,
            });

            axios
                .get(constants.warmUpApiUrl + "/roomV2", {
                    params: {body: payload},
                })
                .then((res) => {
                    let data = res.data;
                    if (data.success) {
                        let power = data.body.room.runMode !== "off";
                        let temp = data.body.room.fixedTemp / 10;
                        let tempProbe = data.body.room.currentTemp / 10;
                        let updatePayload = {
                            power: power,
                            temp: temp,
                            temp_probe: tempProbe,
                        };

                        firebase
                            .database()
                            .ref("devices")
                            .child(device.serialnumber)
                            .child("data")
                            .update(updatePayload);
                    }
                });
        },
    },
};
